import angular from 'angular';
import constants from 'app/constants';
import {
  assetDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './sync-asset-confirm-dialog.controller';
import template from './sync-asset-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, asset, assetType, isMultipleAssets, assets,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'syncConfirmDialogVM',
      locals: {
        customerId,
        asset,
        assetType,
        isMultipleAssets,
        assets,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.asset.syncAssetConfirmDialog', [
  alerts,
  assetDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('syncAssetConfirmDialog', dialogService)
  .name;
